export default class CsrfToken {
  static get() {
    const metaEl = document.querySelector('meta[name="csrf-token"]');
    if (!metaEl) {
      return null;
    }

    return metaEl.getAttribute('content');
  }
}
